import styled from "styled-components";
import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";
import { FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";

const Wrapper = styled(FlexDiv)`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-width: 386px;
  margin: 0 auto;
`;

const CheckIcon = styled(StyledSvgSprite)`
  transform: rotate(15.66deg);
  margin-bottom: 25px;
  height: 45px;
  width: 45px;
  fill: ${theme.colors.textGradient.type3static};
`;

const Title = styled(Typography)`
  text-align: center;
  color: ${theme.colors.gray_100};
  margin-bottom: 35px;
`;

const SubTitle = styled(Typography)`
  text-align: center;
  color: ${theme.colors.gray_100};
`;

export { FlexDiv, CheckIcon, Wrapper, Title, SubTitle };
